import { setRecoil } from "recoil-nexus";
import roomsState from "../../atoms/rooms";
import { socket } from "../index";
import { UserDetail } from "../type";

interface ListenReceiveRoomDetailPayload {
  id: string;
  owner: string;
  participants: number;
  uniqueParticipants: number;
  name: string;
  description: string;
  maxParticipants: number;
  isPremium: boolean;
  isSecret: boolean;
  ownerDetail: UserDetail;
}

const listenReceiveRooms = () => {
  socket?.on('RECEIVE_ROOMS', (payload: ListenReceiveRoomDetailPayload[]) => {
    setRecoil(roomsState, payload);
  });
}

export default listenReceiveRooms;